module.exports = __webpack_public_path__ + "img/audio_wave.3c9a3a88.gif";